import Resource from "../utils/resource";

export const users = new Resource("users");
